<div *ngIf="modo==='flotante'">
    <div class="relative w-full">
        <div class="flex items-center justify-center sm:justify-end sm:pr-16 py-4">
            <button
                class="cursor-pointer bg-accent text-surface border-none rounded-md px-10 py-5 text-lg font-bold uppercase shadow-sm transition-base duration-base hover:bg-accent-hover hover:shadow-md hover:-translate-y-0.5"
                (click)="arrepentimiento()"
            >
                Botón de Arrepentimiento
            </button>
        </div>
    </div>
</div>
